
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The inaugural release of PX Blue 2.0 is the first release of our newly updated Design System. We now support a wide range of platforms and technologies with comprehensive documentation for using the design system.`}</p>
    <h3>{`Themes`}</h3>
    <p>{`Theme file are available for each supported framework. PX Blue 2.0 comes with four themes:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Blue`}</strong>{` is the default theme for all PX Blue applications.`}</li>
      <li parentName="ul"><strong parentName="li">{`Blue-Dark`}</strong>{` is complementary to the Blue theme. The primary use for Blue-Dark is in detail panels (i.e., information sidebars).`}</li>
      <li parentName="ul"><strong parentName="li">{`Red`}</strong>{` is used to indicate an alarm or error condition on a section of your application.`}</li>
      <li parentName="ul"><strong parentName="li">{`Red-Dark`}</strong>{` is complementary to the Red theme. The primary use for Red-Dark is in detail panels (i.e., information sidebars) that accompany a view that uses the Red theme.`}</li>
    </ul>
    <h3>{`The pxblue.github.io website`}</h3>
    <p>{`The PX Blue documentation website provides code examples and snippets for all of the components in the design system. It also provides downloadable assets for icons, colors, and even sticker sheets for designers. You'll find guidance for everything from typography to setting up your development environment. If you were a PX Blue 1.0 developer, you'll find advice on migrating to the new system.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;